import React, { useState, useEffect } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Filler } from "chart.js";
import { Line } from "react-chartjs-2";
import TransferenciasGlobaisApi from '../../services/robinhood/TransferenciasGlobaisApi';

ChartJS.register(CategoryScale, Legend, Tooltip, ArcElement, LinearScale, PointElement, LineElement, Filler)

export default function TransferenciasGlobaisChart(props) {
    const backgroundColor = props.backgroundColor ? props.backgroundColor : 'rgba(127, 204, 156, 0.3)';
    const borderColor = props.borderColor ? props.borderColor : 'rgba(2, 204, 156, 0.75)';
    const options = {
        responsive: true,
        elements: {
            line: {
                tension: 0.3
            }
        },
    };

    const labels = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    const data = {
        labels,
        datasets: [
            {
                label: 'VALOR DE TRANSFERÊNCIA LÍQUIDA NO ANO',
                data: props.dados,
                borderColor: borderColor,
                backgroundColor: backgroundColor,
                // fill: {
                //     target: "origin", // 3. Set the fill options
                //     above: "rgba(161, 234, 154, 0.3)"
                // }

            },
        ],
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row clearfix">
                    <div className="col-md-12" style={{ marginBottom: '' }}>
                        <div className="card" >
                            <div className="header" style={{ marginBottom: '-30px' }}>
                                <h5 style={{ marginBottom: '0px' }}>TRANSFERÊNCIAS DE  <span style={{ color: 'rgba(2, 204, 156, 0.75)' }}> {props.ano} </span> </h5>
                            </div>
                            <div className="body m-b-0" style={{ marginBottom: '' }}>
                                <Line options={options} data={data} height={25} style={{ minHeight: '120px' }} />
                            </div>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
